import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import "./ProductCard.css"
import { Grid2,Paper} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Button from '../Button/Button';
import { Link } from 'react-router-dom';

export function ProductCard({itemData}) {
  const ItemData=itemData
  return (
    <Card component={Paper} elevation={4}  className='Cardcontainer' sx={{borderRadius:{xs:"0px !important",sm:"25px !important"}}}>
      <Link to={`/products/${ItemData.Category}/${ItemData.itemName}/${ItemData.id}`}>
    <CardActionArea className='Cardarea' sx={{padding:{xs:"5px !important",sm:"10px !important"}}}>
      <CardMedia className='Cardimage' component="img" height="140" image={require(`../../assets/Products/${itemData?.image}.jpg`)} alt="BengalGram" sx={{borderRadius:{xs:"0px !important",sm:"25px !important"}}}/>
      <CardContent className='Cardcontent'>
      <Typography className='Cardcontenttext' variant="body2" sx={{ color: 'text.secondary' }}>{itemData.Category}</Typography>
        <Typography className='Cardcontentheading' gutterBottom variant="h5" component="div">{itemData.itemName}</Typography>
        <Grid2 className='Cardstars'>
         {itemData.rating>=1? <StarIcon sx={{fontSize:"17px"}}/>:itemData.rating>=0.5? <StarHalfIcon sx={{fontSize:"17px"}}/>:<StarBorderIcon sx={{fontSize:"17px"}}/>}
         {itemData.rating>=2? <StarIcon sx={{fontSize:"17px"}}/>:itemData.rating>=1.5? <StarHalfIcon sx={{fontSize:"17px"}}/>:<StarBorderIcon sx={{fontSize:"17px"}}/>}
         {itemData.rating>=3? <StarIcon sx={{fontSize:"17px"}}/>:itemData.rating>=2.5? <StarHalfIcon sx={{fontSize:"17px"}}/>:<StarBorderIcon sx={{fontSize:"17px"}}/>}
         {itemData.rating>=4? <StarIcon sx={{fontSize:"17px"}}/>:itemData.rating>=3.5? <StarHalfIcon sx={{fontSize:"17px"}}/>:<StarBorderIcon sx={{fontSize:"17px"}}/>}
         {itemData.rating>=5? <StarIcon sx={{fontSize:"17px"}}/>:itemData.rating>=4.5? <StarHalfIcon sx={{fontSize:"17px"}}/>:<StarBorderIcon sx={{fontSize:"17px"}}/>}
          <Typography sx={{color:"#444",fontSize:"12px"}}>({itemData.rating})</Typography>
          <Typography sx={{color:"#444",display:"flex",justifyContent:"center",fontSize:"12px"}}><PersonIcon sx={{color:"#154A72",fontSize:"17px"}}/>({itemData.noofreviews})</Typography>
        </Grid2>
        <Grid2 container gap="10px">
          <Typography className="itemprice" variant='h5'><CurrencyRupeeIcon sx={{fontSize:"20px"}} />{itemData.price}</Typography>
          <Typography className="itemprice" variant='h5' sx={{color:"gray !important", fontSize:"18px", fontWeight:"500 !important", textDecoration:"line-through"}}><CurrencyRupeeIcon sx={{fontSize:"18px",color:"gray"}} />{itemData.prevPrice}</Typography>
        </Grid2>
          <Grid2 className="addcarticon" sx={{display: { xs: "none !important",sm:"flex !important", md:"flex !important" }}}>
          <ShoppingCartIcon sx={{fontSize:"20px"}}/>
          </Grid2>
          <CardActions sx={{padding:"5px 0px 0px 0px",display: { xs: "flex !important",sm:"none !important", md:"none !important" }}} >
              <Button  label="Add To Cart" width="100%"/>
          </CardActions>
      </CardContent>
    </CardActionArea >
    </Link>
  </Card>
  )
}

